import { showToast, updateToast } from '@lokalise/louis';

import type { ToastEvent, ToastUpdateEvent } from './types';

const SetupToastEvents = () => {
    window.addEventListener('toast', (event: ToastEvent) => {
        showToast(event.detail);
    });

    window.addEventListener('toast:update', ({ detail: { toastId, updates } }: ToastUpdateEvent) => {
        updateToast(toastId, updates);
    });
};

export default SetupToastEvents;
